<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import UserModal from "./UserModal.vue"
import UserEditModal from "./UserEditModal.vue"
import UserChangePassModal from "./UserChangePassModal.vue"
import UsersTable from "./UsersTable.vue"

const title = "مدیریت کاربران"
const pageTitle = "داشبورد"

const DEFAULT_USER = {
  id: "",
  name: "",
  email: "",
  password: "",
  password_confirmation: "",
  status: "",
}

const userModel = ref({ ...DEFAULT_USER })
const showUserModal = ref(false)
const showUserEditModal = ref(false)
const showUserChangePassModal = ref(false)

const showAddNewModal = () => {
  showUserModal.value = true
}

const showChangePassModal = () => {
  showUserChangePassModal.value = true
}

const showEditModal = () => {
  showUserEditModal.value = true
}

const editUser = (usr) => {
  userModel.value = usr
  showEditModal()
}

const changePassUser = (usr) => {
  userModel.value = usr
  showChangePassModal()
}

const onModalClose = () => {
  userModel.value = { ...DEFAULT_USER }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :pageTitle="pageTitle" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="userList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست کاربران</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i>افزودن کاربر
                    جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- users table  -->

          <UsersTable @clickEdit="editUser" @clickChangePass="changePassUser" />

          <!-- add and edit user modal  -->

          <UserModal
            v-model="showUserModal"
            :user="userModel"
            @close="onModalClose"
          />

          <UserEditModal
            v-model="showUserEditModal"
            :user="userModel"
            @close="onModalClose"
          />

          <UserChangePassModal
            v-model="showUserChangePassModal"
            :user="userModel"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
